module.exports = __webpack_public_path__ + "static/media/Intro-after-trail.e99f5100.mp3";